export default __webpack_public_path__ + "static/media/gflac1.ba9115db.jpg";